export default __webpack_public_path__ + "static/0161-71ac2251ef8a1ee3b2f8d1a58913043a.png";